import React from "react";
import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Row,
	Col,
	Table,
	UncontrolledTooltip
} from "reactstrap";
import moment from "moment";
//import Async from 'react-select/async';
//import Datetime from "react-datetime";
//import { isEqual } from 'lodash';

// Components
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import PaginationComponent from "../../components/Custom/Pagination";
// Helpers
import { hasPermission } from "helpers/auth";
import { formatPrice } from "../../helpers/pricing";
import { calcStartEndPage } from '../../helpers/pagination';
// Contexts
import ProjectContext from "contexts/ProjectContext";
// Assets
//import { ReactComponent as IEye } from '../../assets/icons/eye.svg'
//import { ReactComponent as ISlashedEye } from '../../assets/icons/slashedEye.svg'
//import { ReactComponent as IClear } from '../../assets/icons/clear.svg'
// Requests
import { getCommissionsRequest, deleteCommissionRequest } from '../../api/commissions';
import { getClientsRequest } from "api/client";
import { 
    getSellersRequest, 
    //getSellerRequest 
} from "api/seller";
//import { getClientRequest } from "api/client";

class Commissions extends React.Component {

    constructor(props) {
		super(props);
		this.state = {
			commissions: null,
			total: 0,
			pages: 0,
			current_page: 0,
			start_page: 0,
			end_page: 9,
			first_page: 0,
			last_page: 0,
			deleteCommissionId: '',
			start_date: '',
			end_date: '',
			selectedCommissions: {},
			commissionBulkMessage: null,
			commissionBulkSuccess: null,
			filters: { limit: 25, page: 0 },
			filtersClients: {},
			filtersSellers: {},
            loading: true,
            isCollapseOpen: true,
            selectedClient: null,
            selectedSeller: null
		}
		this.timeout = null;
	}
    static contextType = ProjectContext;

    /*async componentDidMount() {
        this.previousContext = this.context;

        const commissionsFilter = JSON.parse(localStorage.getItem('commissionsFilter')) || this.state.filters;
		if(commissionsFilter.client) {
			getClientRequest(commissionsFilter.client).then(client => {
				this.setState({
					selectedClient: { label: `${client.first_name} ${client.last_name}`, value: client._id, data: client }
				});
			})
		}
		if(commissionsFilter.seller) {
			getSellerRequest(commissionsFilter.seller).then(seller => {
				this.setState({
					selectedSeller: { label: `${seller.first_name} ${seller.last_name}`, value: seller._id, data: seller }
				});
			})
		}
        
        this.setState({
			filters: {...commissionsFilter},
		}, async () => {
			await this.getCommissions();
		});
	}*/

    async componentDidMount() {
        await this.getCommissions();
    }

    /*async componentDidUpdate(prevProps, prevState) {
		if(this.previousContext.selectedProject !== this.context.selectedProject) {
			this.previousContext.selectedProject = this.context.selectedProject
			await this.getCommissions()
		}

        if(!isEqual(prevState.filters, this.state.filters)) {
			localStorage.setItem('commissionsFilter', JSON.stringify({...this.state.filters}));
		}
    }*/

    goTo = path => this.props.history.push(path);

    goToPage = async (page) => {
		const { pages, filters } = this.state;
		const { start_page, end_page } = calcStartEndPage(page, pages);

		this.setState({
			filters: {...filters, page},
			start_page: start_page,
			current_page: page,
			end_page: end_page,
		}, this.getCommissions);
	};

    getCommissions = async () => {
        this.setState ({
            loading:true
        })
        try {
            const { filters } = this.state;
            const { selectedProject } = this.context

		    filters.project = selectedProject
            
            const commissionsObj = await getCommissionsRequest(filters);                    
            const total = commissionsObj.total;
            const pages = Math.ceil(total / filters.limit);
            const last_page = pages - 1;
            const end_page = pages > 10 ? 9 : pages - 1;
    
            this.setState({
                commissions: commissionsObj.commissions,
                total,
                pages,
                last_page,
                end_page,
                loading: false
            })

        } catch (err) {
            console.log(err)
        }
	}

    openConfirmation = (commissionId) => () => {
		this.setState({
			deleteCommissionId: commissionId
		});
		this.deleteConfirmationModal.toggle();
    }

    calculateTotalAmount = (commission) => {
		const {
			amount,
			extras
		} = commission;
		const entries = [amount, extras].filter(item => !!Number(item));
		const totalEntries = entries.length ? entries.reduce((item1, item2) => Number(item1)+Number(item2)) : 0;
		return totalEntries;
	}

    formatPaymentInfo = (commission) => {
        if (!commission.payment) {
            return "N/A";
        }

        const dueDate = moment(commission.payment.due_date).format("MM/DD/YYYY");
        const settledDate = moment(commission.payment.settled_date).format("MM/DD/YYYY");
        const subType = commission.payment.subtype;

        return (
            <div>
                <div className="">Due date: {dueDate}</div>
                <div className="">Settled date: {settledDate}</div>
                <div className="">Amount: {formatPrice(commission.payment.amount)}</div>
                <small className="text-muted">{subType}</small>
            </div>
        )
    }

    formatUnitInfo = (commission) => {
        if (!commission.unit) {
            return "N/A";
        }

        return (
            <div>
                <div className="font-weight-bold">{commission.client ? `${commission.client.first_name} ${commission.client.last_name}` : "N/A"}</div>
                <div className="">Lot {commission.unit.lot_number} Block {commission.unit.block_number}</div>
            </div>
        )
    }

    formatRecipientInfo = (commission) => {
        if (!commission.recipientType || !commission.recipientId) {
            return "N/A";
        }

        const recipient = commission.recipientId;
        const type = commission.recipientType;

        if (type === 'broker') {
            return (
                <div>
                    <div className="font-weight-bold">{recipient.name || "N/A"}</div>
                    <small className="text-muted">Broker</small>
                </div>
            );
        } else if (type === 'seller') {
            const fullName = `${recipient.first_name || ""} ${recipient.last_name || ""}`.trim();
            return (
                <div>
                    <div className="font-weight-bold">{fullName || "N/A"}</div>
                    <small className="text-muted">Seller</small>
                </div>
            );
        }

        return "N/A";
    }

    formatCommissionCalculations = (commission) => {
        return (
            <div>
                <div>Commissionable: {formatPrice(commission.commissionable_amount)}</div>
                <div>Cleared: {(commission.cleared_percentage * 100).toFixed(2)}%</div>
            </div>
        )
    }

    formatCommissionAmount = (commission) => {
        return (
            <div>
                <div>Amount: {formatPrice(commission.amount)}</div>
                <div>VAT: {formatPrice(commission.vat_amount)}</div>
                <div>Withholding Tax: {formatPrice(commission.withholding_tax)}</div>
                <div>Net Due: {formatPrice(commission.amount_net_due)}</div>
            </div>
        )
    }

    deletePayment = async () => {
		const { deleteCommissionId } = this.state;
        await deleteCommissionRequest(deleteCommissionId);
        this.getCommissions()
	}

    onChangeDateFilter = (key) => (date) => {
		if(key === 'end_date') {
			date = date.endOf('day');
		}
		this.setState({
			[key]: date
		}, () => {
			const { filters, start_date, end_date } = this.state;

			if(start_date && end_date) {
				this.setState({
					filters: {
						...filters,
						start_date: start_date && start_date.toISOString(),
						end_date: end_date && end_date.toISOString(),

					}
				},this.getCommissions);
			}
		});
	};

    isValidStartDate = (current) => {
		// return current < moment();
		return true;
	}

	isValidEndDate = (current) => {
		const { start_date } = this.state;

		if(start_date) {
			return current.diff(start_date, 'days') >= 0;
		}
	}

    loadClients = async (search, callback) => {
		const { filtersClients } = this.state;
		this.setState({
			filtersClients: {
				...filtersClients,
				search
			}
		})
		if(search) {
			const clientResponse = await getClientsRequest(filtersClients);
			const clients = clientResponse.clients.map(client => {
				return {
					data: client,
					label: `${client.first_name} ${client.last_name}`,
					value: client._id
				}
			})
			callback(clients);
		}
	}

    loadSellers = async (search, callback) => {
		const { filtersSellers } = this.state;
		this.setState({
			filtersSellers: {
				...filtersSellers,
				search
			}
		})
		if(search) {
			const sellerResponse = await getSellersRequest(filtersSellers);
			const sellers = sellerResponse.sellers.map(seller => {
				return {
					data: seller,
					label: `${seller.first_name} ${seller.last_name}`,
					value: seller._id
				}
			})
			callback(sellers);
		}
	};

    onSelectChange = (key) => (object) => {
		const { filters } = this.state;

        if(!object) {
            this.setState({
                filters: {...filters, [key]: ""}
            }, () => {
                this.getCommissions();
            })
            return;
        }
        this.setState({
             filters: {...filters, [key]: object.value}
        }, () => {
            this.getCommissions();
        })

	}

    onChangeAsyncSelect = (key) => (object) => {
        let keySelect; 

        console.log(object)

        switch(key) {
            case 'client':
                keySelect = 'selectedClient'
            break;
            case 'seller':
                keySelect = 'selectedSeller'
            break;
            default: keySelect = ''
        }

		if(!object) {
            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    [key]: '',
                },
                [keySelect]: ''
            }), this.getCommissions)
            return;
        }

		this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [key]: object.value,
            },
            [keySelect]: object
		}), this.getCommissions)
    }

    onChangeSearch = (event) => {
		const search = event.target.value;
		const { filters } = this.state; 
		this.setState({
			filters: {...filters , search},
			page: 0
		})
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			this.getCommissions();
		}, 300);
	}

    onChangeStatus = (event) => {
		const status = event.target.value
		const { filters } = this.state;

		this.setState({
			filters: {...filters, status}
		}, this.getCommissions);
	}

    collapseHandler = () => {
        this.setState(prevState => ({
            isCollapseOpen: !prevState.isCollapseOpen
        }))
    }

    cleanFilters = () => {
        this.setState({
            filters: {
                limit: 25,
                page: 0,
                search: ''
            },
            start_date: '',
            end_date: '',
            selectedClient: null,
            selectedSeller: null,
        }, this.getCommissions)
    }
    
    render() {

        const {
            commissions,
            loading,
            start_page,
            pages,
            current_page,
            end_page,
            //start_date,
            //end_date,
            //filters,
            //isCollapseOpen,
        } = this.state;

        /*const {
			search,
			status,
			selectedClient,
            selectedSeller
		} = filters;*/

        return (
            <>
                <div className="content">
                    <Row>
                        <Col md="12">   
                            <Card>
                                <CardHeader>
                                    <Row className='mb-3'>
                                        <Col>
                                            <CardTitle className="d-inline-block" tag="h4">Commissions</CardTitle>
                                        </Col>
                                    </Row>
                                    {/*<Row>
										<Col className="d-flex justify-content-end">
                                            <Button id='show-hide' className="filters-btn" onClick={this.collapseHandler}>
												{isCollapseOpen ? 
													<>
														<ISlashedEye/>
														<UncontrolledTooltip
															delay={0}
															target='show-hide'
														>
															Hide filters
														</UncontrolledTooltip>
													</>
												: 
													<>
														<IEye/>
														<UncontrolledTooltip
															delay={0}
															target='show-hide'
														>
															Show filters
														</UncontrolledTooltip>
													</>
												}
											</Button>
											<Button id="clean" className="filters-btn" onClick={this.cleanFilters}>
												<IClear/>
												<UncontrolledTooltip
													delay={0}
													target='clean'
												>
													Clean filters
												</UncontrolledTooltip>
											</Button>
										</Col>
									</Row>
                                    <Collapse isOpen={isCollapseOpen}>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup>
                                                    <Label>Start Date</Label>
                                                    <Datetime
                                                        inputProps={{
                                                            className: "form-control",
                                                            placeholder: "Start Date",
                                                            name: "start_date"
                                                        }}
                                                        timeFormat={false}
                                                        value={start_date}
                                                        onChange={this.onChangeDateFilter('start_date')}
                                                        isValidDate={this.isValidStartDate}
                                                        closeOnSelect={true}
                                                        dateFormat="DD/MM/YYYY"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6">
                                                <FormGroup>
                                                    <Label>End Date</Label>
                                                    <Datetime
                                                        inputProps={{
                                                            className: "form-control",
                                                            placeholder: "End Date",
                                                            name: "end_date"
                                                        }}
                                                        timeFormat={false}
                                                        value={end_date}
                                                        onBlur={this.onChangeDateFilter('end_date')}
                                                        isValidDate={this.isValidEndDate}
                                                        closeOnSelect={true}
                                                        dateFormat="DD/MM/YYYY"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <FormGroup>
                                                    <Label>Search</Label>
                                                    <Input placeholder="Search..." value={search} type="text" onChange={this.onChangeSearch}></Input>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Collapse>*/}
                                </CardHeader>
                                <CardBody>
                                    <Table responsive>
                                        <thead className="text-primary">
                                            <tr>
                                                {/* {hasPermission('EditPayment') ? <th><input type="checkbox" onChange={this.selectAll} checked={this.getSelectedPaymentIds().length === (payments && payments.length)} /></th> : null} */}
                                                <th>Created</th>
                                                <th>Unit</th>
                                                <th>Payment</th>
                                                <th>Recipient</th>
                                                <th>Calculations</th>
                                                <th>Commission Amount</th>
                                                <th className="text-right">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ?
                                                <tr>
                                                    <td colSpan="11">Loading...</td>
                                                </tr>
                                            :
                                                (commissions && commissions.length > 0) ? 
                                                commissions?.map((commission) => {

                                                        return (
                                                            <tr key={commission._id}>
                                                                <td>{moment(commission.created_at).format("MM/DD/YYYY")}</td>
                                                                <td>{this.formatUnitInfo(commission)}</td>
                                                                <td>{this.formatPaymentInfo(commission)}</td>
                                                                <td>{this.formatRecipientInfo(commission)}</td>
                                                                <td>{this.formatCommissionCalculations(commission)}</td>
                                                                <td>{this.formatCommissionAmount(commission)}</td>
                                                                <td className="text-right">
                                                                    <Button
                                                                        className="btn-link btn-icon"
                                                                        color="success"
                                                                        id={`tooltip-view-${commission._id}`}
                                                                        size="sm"
                                                                        onClick={() => this.goTo(`/commission?id=${commission._id}`)}
                                                                    >
                                                                        <i className="tim-icons icon-zoom-split" />
                                                                    </Button>
                                                                    <UncontrolledTooltip
                                                                        delay={0}
                                                                        target={`tooltip-view-${commission._id}`}
                                                                    >
                                                                        View
                                                                    </UncontrolledTooltip>
                                                                    {hasPermission('EditCommission') ? <> 
                                                                        <Button
                                                                            className="btn-link btn-icon"
                                                                            color="info"
                                                                            id={`tooltip-edit-${commission._id}`}
                                                                            size="sm"
                                                                            onClick={() => this.goTo(`/commission/edit?id=${commission._id}`)}
                                                                        >
                                                                            <i className="tim-icons icon-pencil" />
                                                                        </Button>
                                                                        <UncontrolledTooltip
                                                                            delay={0}
                                                                            target={`tooltip-edit-${commission._id}`}
                                                                        >
                                                                            Edit
                                                                        </UncontrolledTooltip>
                                                                    </> : null}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                : 
                                                    <tr>
                                                        <td colSpan="11">There's no commission to show</td>
                                                    </tr>
                                                }
                                        </tbody>
                                    </Table>
                                    {commissions?.length > 0 &&
										<PaginationComponent
											pages={pages}
											current_page={current_page}
											start_page={start_page}
											end_page={end_page}
											goToPage={this.goToPage}
										/>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <ConfirmationModal
						ref={el => this.deleteConfirmationModal = el}
						title="Delete Commission?"
						buttons={[
							{ title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
							{ title: 'Delete', className: 'btn-danger-override btn btn-danger', onClick: this.deletePayment }
						]}
					>
						Are you sure you want to delete this commission?
					</ConfirmationModal>
                </div>
            </>
        )
    }
}

export default Commissions;